import cn from 'classnames';
import PropTypes from 'prop-types';
import { AppLoaderCymbioImage } from '../../../containers/common/AppLoader/AppLoaderCymbioImage';
import styles from './CymbioSpinner.module.scss';

export function CymbioSpinner(props) {
  const { shouldCenterVerticallyInViewport = false } = props;

  return (
    <div className={cn(styles.wrapper, shouldCenterVerticallyInViewport ? styles.centerVertically : '')}>
      <AppLoaderCymbioImage />
    </div>
  );
}

CymbioSpinner.propTypes = {
  shouldCenterVerticallyInViewport: PropTypes.bool,
};
